export const modalConstants = {
  SHOW: "MODAL_SHOW",
  HIDE: "MODAL_HIDE"
};